module.exports = __webpack_public_path__ + "static/media/icon_186.294277d9.svg";